import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import CardHeaderBackgroundComponent from "../../components/cardHeaderBackground";
import ContainerComponent from "../../components/conatiner";
import HeaderComponent from "../../components/header";
import InputComponent from "../../components/input";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { ICity, IState } from "../../types";
import TableComponent from "../../components/table";
import LoadingComponent from "../../components/loading";
import { StatesAllService } from "../../services/states";
import { ToastErro, ToastSucesso } from "../../components/toast";
import { CitiesService, CityCreateService, CityDeleteService } from "../../services/cities";
import ModalComponent from "../../components/modal";

const CitiesPage = () => {

    const [loading, setLoading] = useState<boolean>(true);
    const [loadingStates, setLoadingStates] = useState<boolean>(true);

    const [states, setStates] = useState<IState[]>([]);
    const [cities, setCities] = useState<any>([]);

    // variaveis de pesquisa
    const [description, setDescription] = useState<string>('');
    const [state, setState] = useState<number>(null!);
    const [page, setPage] = useState<number>(1);
    // variaveis de pesquisa

    // variaveis para cadastrar
    const [createDescription, setCreateDescription] = useState<string>('');
    const [createState, setCreateState] = useState<number>(null!);
    // variaveis para cadastrar

    // função para pesquisar estados
    const getStates = async () => {

        setLoadingStates(true);

        await StatesAllService().then(resp => {
            setStates(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoadingStates(false);

    }
    // função para pesquisar estados

    // função para pesquisar cidades
    const getCities = async () => {

        setLoading(true);

        await CitiesService(description, state, page).then(resp => {
            setCities(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // função para pesquisar cidades

    // função para cadastrar cidade
    const createCity = async (e: FormEvent<HTMLFormElement>) => {

        e.preventDefault();

        // verificar se os campos foram preenchidos
        if (createDescription.length < 1 || createState == null) {
            ToastErro('Preencha todos os campos!');
            return;
        }
        // verificar se os campos foram preenchidos

        (window as any).$("#modalCreate").modal('hide');

        setLoading(true);

        await CityCreateService(createDescription, createState).then(resp => {
            ToastSucesso(resp.data.message);
            getCities();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
            (window as any).$("#modalCreate").modal('show');
        });

    }
    // função para cadastrar cidade

    // função para desativar cidade
    const disableCity = async (id: number) => {

        (window as any).$("#modalDisabled" + id).modal('hide');

        setLoading(true);

        await CityDeleteService(id).then(resp => {
            ToastSucesso(resp.data.message);
            getCities();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para desativar cidade

    useEffect(() => {
        getStates();
    }, []);

    useEffect(() => {
        getCities();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="Cidades"
                button="Cidade"
                iconButton="add"
                onClick={() => (window as any).$("#modalCreate").modal('show')}
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        {
                            loadingStates

                                ?

                                <LoadingComponent />

                                :

                                <div className="row">
                                    <InputComponent
                                        label="Cidade"
                                        col={4}
                                        size={"small"}
                                        defaultValue={description}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)}
                                    />
                                    <div className="col-md-4">
                                        <FormControl
                                            fullWidth
                                            size="small"
                                        >
                                            <InputLabel>Estado</InputLabel>
                                            <Select
                                                value={state}
                                                label="Estado"
                                                onChange={(e: any) => setState(e.target.value)}
                                            >
                                                {
                                                    states.map((s: IState) => {
                                                        return <MenuItem key={s.id} value={s.id}>{s.description}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-md-4">
                                        <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getCities()}>Pesquisar</button>
                                    </div>
                                </div>
                        }
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Cidades"
                        columns={['ID', 'Cidade', 'Estado', 'Ativo', 'Ações']}
                        loading={loading}
                        page={page}
                        last_page={cities?.last_page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                    >
                        {
                            cities?.data?.map((c: ICity) => {
                                return (
                                    <tr key={c.id}>
                                        <td className="px-4">{c.id}</td>
                                        <td className="px-4">{c.city}</td>
                                        <td className="px-4">{c.state}</td>
                                        <td className="px-4">
                                            {
                                                c.active == 1

                                                    ?

                                                    <h5><span className="badge bg-success">Sim</span></h5>

                                                    :

                                                    <h5><span className="badge bg-danger">Não</span></h5>
                                            }
                                        </td>
                                        <td className="px-4">
                                            <button className="btn btn-text-danger" type="button" title={c.active == 1 ? 'Desativar' : 'Ativar'} onClick={() => (window as any).$(`#modalDisabled${c.id}`).modal('show')}><i className="material-icons">{c.active == 1 ? 'delete' : 'upload'}</i></button>

                                            <ModalComponent
                                                title={c.active == 1 ? 'Desativar Cidade' : 'Ativar Cidade'}
                                                id={`modalDisabled${c.id}`}
                                            >
                                                <>
                                                    <p>Você tem certeza que deseja {c.active == 1 ? 'desativar' : 'ativar'} a cidade abaixo?</p>
                                                    <table className="table mt-4">
                                                        <tbody>
                                                            <tr>
                                                                <td>Cidade:</td>
                                                                <td>{c.city}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Estado:</td>
                                                                <td>{c.state}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div className="d-flex justify-content-end mt-4">
                                                        <button className="btn btn-primary" type="button" onClick={() => disableCity(c.id)}>{c.active == 1 ? 'Desativar' : 'Ativar'}</button>
                                                    </div>
                                                </>
                                            </ModalComponent>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>

                    <ModalComponent
                        title="Cadastrar Cidade"
                        id="modalCreate"
                    >
                        <form onSubmit={createCity}>
                            <div className="row mt-3">
                                <InputComponent
                                    label="Cidade"
                                    col={12}
                                    defaultValue={createDescription}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCreateDescription(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <FormControl
                                        fullWidth
                                    >
                                        <InputLabel>Estado</InputLabel>
                                        <Select
                                            value={createState}
                                            label="Estado"
                                            onChange={(e: any) => setCreateState(e.target.value)}
                                            required
                                        >
                                            {
                                                states.map((s: IState) => {
                                                    return <MenuItem key={s.id} value={s.id}>{s.description}</MenuItem>;
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="submit">Cadastrar</button>
                            </div>
                        </form>
                    </ModalComponent>
                </>
            </ContainerComponent>
        </>
    )

}

export default CitiesPage;